import { defineStore } from "pinia";
import axios from "axios";
import { useLoadingStore } from "@/stores/loadingStore";

export const useFaqsStore = defineStore("faqsStore", {
  state: () => ({
    faqs: [],
    isLoading: false,
    error: null,
  }),
  actions: {
    async fetchFaqs() {
      const loadingStore = useLoadingStore();
      loadingStore.startLoading();
      this.isLoading = true;
      this.error = null;
      try {
        const response = await axios.get("/api/KnowledgeBase/GetFaqs");
        this.faqs = response.data.Payload;
      } catch (error) {
        this.error = "Sık Sorulan Sorular alınırken bir hata oluştu";
      } finally {
        this.isLoading = false;
        loadingStore.finishLoading();
      }
    },
  },
});
